import { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';

export type TableColumn<T> = {
  id: keyof T;
  label: ReactNode;
  renderer: (model: T) => ReactElement;
};

export enum RowColoring {
  DANGER = 'danger',
  WARNING = 'warning',
  SUCCESS = 'success',
}

type TableRowProps<T> = {
  columns: TableColumn<T>[];
  model: T;
  highlighted: boolean;
  onClick: () => void;
  disabled: boolean;
  coloring?: RowColoring;
};

export const TableRow = <T extends object>({
  columns,
  model,
  highlighted,
  onClick,
  disabled,
  coloring,
}: TableRowProps<T>): ReactElement | null => {
  const handleClickOnRow = () => {
    if (disabled) {
      return;
    }

    onClick();
  };

  const cells = columns.map((column, index) => {
    const render = column.renderer;
    return (
      <td
        key={index}
        data-field={column}
      >
        {render(model)}
      </td>
    );
  });

  const classes = classNames('cursor-pointer', {
    active: highlighted,
    [`coloring ${coloring}`]: coloring,
    disabled,
  });

  return (
    <tr
      className={classes}
      onClick={handleClickOnRow}
    >
      {cells}
      <td className="padding-0 text-center">
        <span
          data-testid="table-row-click-indicator"
          className={
            'margin-left-auto rioglyph rioglyph-chevron-right text-color-primary'
          }
        />
      </td>
    </tr>
  );
};
